<template lang="pug">
el-container(id="NetworkEdit-container")
  el-dialog(:visible.sync="mutableEditDialogVisible", fullscreen=false, :title="$t('Edit network')", :before-close="beforeCloseHandler", :close-on-click-modal="false", append-to-body)
    el-form(
      id="NetworkEdit-form",
      :model="networkData",
      :rules="rules",
      ref="networkForm",
      label-width="180px",
      status-icon=true,
      :size="uxParam('formSize')",
      v-loading="loading",
    )
      el-form-item(:label="$t('Name')", prop="name")
        el-input(id="NetworkEdit-formNameInput" v-model="networkData.name")
      el-form-item(:label="$t('Description')", prop="description")
        el-input(id="NetworkEdit-formDescriptionInput" v-model="networkData.description", type="textarea", :autosize="{ minRows: 2, maxRows: 4}")
      el-form-item(:label="$t('Client')", prop="ClientId")
        el-select.el-select-width-100(id="NetworkEdit-formClientSelect", v-model="networkData.ClientId", filterable)
          el-option(
            v-for="item in clientList",
            :key="item.id",
            :label="item.name"
            :value="item.id",
            :id="'NetworkEdit-formClientOption' + item.id"
          )
      hr.header
      el-form-item(:label="$t('Valid To')", prop="validTo")
        el-date-picker(id="NetworkEdit-formValidToInput" v-model="networkData.validTo", type="date")
      el-form-item(:label="$t('Invoice Number')", prop="invoiceNumber")
        el-input(id="NetworkEdit-formInvoiceNumberInput" v-model="networkData.invoiceNumber")
      el-form-item(:label="$t('Contact Person - Name')", prop="contactPersonName")
        el-input(id="NetworkEdit-formContactPersonNameInput" v-model="networkData.contactPersonName")
      el-form-item(:label="$t('Contact Person - Email')", prop="contactPersonEmail")
        el-input(id="NetworkEdit-formContactPersonEmailInput" v-model="networkData.contactPersonEmail")
      el-form-item(:label="$t('Contact Person - Phone')", prop="contactPersonPhone")
        el-input(id="NetworkEdit-formContactPersonPhoneInput" v-model="networkData.contactPersonPhone")
      hr.header
      el-form-item(:label="$t('Conversion profile')", prop="conversionProfile")
        el-select.el-select-width-100(id="NetworkEdit-formConversionSelect" v-model="networkData.conversionProfile")
          el-option(
            v-for="(item, key) in conversionProfiles",
            :key="key",
            :label="key",
            :value="key",
            :id="'NetworkEdit-formNetworkOption' + key"
          )
        p(v-if='conversionProfiles && conversionProfiles[networkData.conversionProfile]') {{ conversionProfiles[networkData.conversionProfile].join(' ') }}
      el-form-item(:label="$t('Convert all images to .mp4:')", prop="mp4images")
        el-switch(id="NetworkEdit-formConvertMP4Switch" v-model="networkData.mp4images", :active-text='$t("convert to .mp4")', :inactive-text='$t("use images")')
      el-form-item(:label="$t('Media Duplicates:')", prop="allowMediaDuplicates")
        el-switch(
          id="NetworkEdit-formMediaDuplicatesSwitch",
          v-model="networkData.allowMediaDuplicates",
          :active-text='$t("allow")',
          :inactive-text='$t("disallow")',
          inactive-color="#13ce66",
          active-color="#ff4949"
        )
      el-form-item(:label="$t('Max upload file size (MB)')", prop="maxUploadSizeMB")
        el-input-number(id="NetworkEdit-formUploadFileInput" v-model="maxUploadSizeMB", @input='validateMaxUploadSizeMB', :min='0')
        p.warning(id="NetworkEdit-uploadDisabledWarning" v-if='maxUploadSizeMB < 1') {{ $t('Upload disabled for network.')}}
        p.warning(id="NetworkEdit-uploadInvalidInputWarning" v-if='incorrectMaxUploadSizeB') {{ $t('Type a number.')}}
      el-form-item(:label="$t('Test functionality:')", prop="test")
        el-checkbox(id="NetworkEdit-formTestCheckbox" v-model="networkData.test", :disabled='networkData.test') {{ $t('Enabled') }}
      el-form-item(:label="$t('Tag-dependancy play functionality:')", prop="playTagDependancyUsed")
        el-checkbox(id="NetworkEdit-formplayTagDependancyUsedCheckbox" v-model="networkData.playTagDependancyUsed") {{ $t('Enabled') }}
      el-form-item(:label="$t('Heartbeat interval (s)')", prop="inactiveAfterS")
        el-input-number(id="NetworkEdit-formHeartbeatInput" v-model="networkData.inactiveAfterS")
      el-form-item(:label="$t('Email inactivity alerts')", prop="alertDowntimesCreated")
        el-switch(id="NetworkEdit-formNetworkEmailAlertsSwitch" v-model="networkData.alertDowntimesCreated", inactive-color="#ff4949", active-color="#13ce66")
      el-form-item(v-if='networkData.alertDowntimesCreated', :label="$t('Alerts Email')", prop="downTimeEmailAddress")
        el-input(id="NetworkEdit-formNetworkEmailAlertsInput" v-model="networkData.downTimeEmailAddress")
      el-form-item(:label="$t('Playlog retention (days)')", prop="retentionPlaylogsDays")
        el-input-number(id="NetworkEdit-formRetentionInput" v-model="networkData.retentionPlaylogsDays")
      el-form-item(:label="$t('Network active')", prop="deleted")
        el-switch(id="NetworkEdit-formNetworkActiveSwitch" v-model="networkData.deleted", inactive-color="#13ce66", active-color="#ff4949")
      //- el-form-item(:label="$t('Deep Nesting:')", prop="allowDeeplyNestedPlaylist")
      //-   el-switch(v-model="networkData.allowDeeplyNestedPlaylist", :active-text='$t("allow")', :inactive-text='$t("disallow")')
    .dialog-footer(slot="footer")
      el-button(
        id="NetworkEdit-submitFormButton",
        type="success",
        size="small"
        @click="submitForm('networkForm')"
        :disabled="loading"
      ) {{$t('Save')}}
</template>

<script>

export default {
  props: {
    'networkId': {
      required: true
    },
    'editDialogVisible': {
      required: true
    }
  },
  data () {
    return {
      loading: true,
      networkData: {
        id: 0,
        name: '',
        description: '',
        allowMediaDuplicates: false,
        allowDeeplyNestedPlaylist: true,
        inactiveAfterS: 300,
        conversionProfile: 'default',
        alertDowntimesCreated: false,
        downTimeEmailAddress: '',
        test: false,
        Client: null,
        ClientId: null
      },
      clientList: {},
      conversionProfiles: {},
      rules: {
        name: [
          { required: true, message: this.$t('Please enter network name'), trigger: 'blur' },
          { min: 3, max: 255, message: this.$t('Length should be 3 to 255'), trigger: 'blur' }
        ],
        ClientId: [
          { required: true, message: this.$t('Please select client'), trigger: 'change' }
        ]
      },
      incorrectMaxUploadSizeB: false
    }
  },
  created () {
    if (this.networkData.id === 0) {
      this.networkData.maxUploadSizeB = 1024 * 1024 * 1024
    }
  },
  watch: {
    networkId: async function (newVal, oldVal) {
      if (newVal === oldVal) return
      this.loading = true
      this.clientList = {}
      this.$nextTick(function () {
        this.$refs['networkForm'].resetFields()
      })

      this.clientList = await this.$store.dispatch('Client/getClients')
      this.conversionProfiles = await this.$store.dispatch('Network/getConversionProfiles')
      if (this.networkId !== null && this.networkId !== 0) {
        const networkData = await this.$store.dispatch('Network/getNetworkData', {
          data: {
            networkId: this.networkId
          },
          options: {
            populate: ['Client']
          }
        })
        networkData.ClientId = networkData.Client.id
        this.networkData = networkData
      }

      this.loading = false
    }
  },
  methods: {
    validateMaxUploadSizeMB (value) {
      this.incorrectMaxUploadSizeB = false
      if (!Number.isInteger(value)) this.incorrectMaxUploadSizeB = true
      if (value < 1) this.networkData.maxUploadSizeB = 0
    },
    async submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true
          this.$store.dispatch(this.networkId === 0 ? 'Network/createNetworkData' : 'Network/updateNetworkData', {
            data: this.networkData
          })
            .then(response => {
              this.mutableEditDialogVisible = false
              this.loading = false
            })
            .catch(error => {
              console.log(error)
              this.loading = false
            })
        } else {
          return false
        }
      })
    },
    beforeCloseHandler: function (done) {
      done()
    }
  },
  computed: {
    mutableEditDialogVisible: {
      get: function () {
        return this.editDialogVisible
      },
      set: function (value) {
        this.$emit('closeEditDialog', value)
      }
    },
    maxUploadSizeMB: {
      get: function () {
        return this.networkData.maxUploadSizeB / 1024 / 1024
      },
      set: function (value) {
        this.networkData.maxUploadSizeB = value * 1024 * 1024
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Network/NetworkEdit.vue